import { NAME } from './constants';

export const LOADING_STARTED = `${NAME}/LOADING_STARTED`;
export const LOADING_DONE = `${NAME}/LOADING_DONE`;
export const SHOW_MESSAGE = `${NAME}/SHOW_MESSAGE`;
export const HIDE_MESSAGE = `${NAME}/HIDE_MESSAGE`;
export const UPDATE_CONTAINER_DIMENSIONS = `${NAME}/UPDATE_CONTAINER_DIMENSIONS`;
export const BLOCK = `${NAME}/BLOCK`;
export const UNBLOCK = `${NAME}/UNBLOCK`;
export const SET_CURRENT_PAGE_TITLE = `${NAME}/SET_CURRENT_PAGE_TITLE`;
